module.exports = __webpack_public_path__ + "img/logo.f7b7712f.svg";